import { _QtLoader } from "@/angular/libs/venus-beta/qtloader";
import { StateParams } from "@uirouter/angularjs";
import angular from 'angular';
import Bowser from "bowser";



(function () {
    angular.module('vrm.core').controller('RemoteConsoleController2', RemoteConsoleController2);

    /**
     * @constructor
     * @ngInject
     */
    function RemoteConsoleController2($state, locale, vrmNotificationsService, vrmNotificationType, ApiService, InstallationsService, $stateParams, UserService, localStorageService, vrmConfig) {

        function open() {
            document.querySelector(".vrm-main__container").classList.add("bodyRC2");

            const browser = Bowser.getParser(window.navigator.userAgent);
            const isMobile = browser.parsedResult.platform.type === 'mobile';

            if (isMobile) {
                var el = document.querySelector('#rc2-rotate');
                el.classList.add('isMobile')
            }

            InstallationsService.getInstallation($stateParams.id).then((installation) => {
                if (!installation.view_permissions.rc_gui_v2) {
                    $state.go("base.installation-overview");

                    if (!installation.view_permissions.share) {
                        locale.ready('core').then(function () {
                            vrmNotificationsService.add({ type: vrmNotificationType.ERROR, message: locale.getString("core.not_allowed_shared_user") });
                        });
                    }
                    if (!installation.view_permissions.rc_gui_v2) {
                        locale.ready('core').then(function () {
                            vrmNotificationsService.add({ type: vrmNotificationType.ERROR, message: locale.getString("core.not_supporting_new_rc") });
                        });
                    }
                }
                else {
                    const user = UserService.user;
                    var spinner = document.querySelector('#qtspinner');
                    var canvas = document.querySelector('#qtcanvas');
                    var statusMessage = document.querySelector('#qtstatus');
                    var errorMessage = document.querySelector('#errstatus');
                    var error = document.querySelector('#rc2error');
                    var loading = document.querySelector('#rc2loading');

                    var qtLoader = new _QtLoader({
                        canvasElements: [canvas],
                        restartLimit: 5,
                        restartMode: "RestartOnExit",
                        showLoader: function (loaderStatus) {
                            spinner.style.display = 'block';
                            canvas.style.display = 'none';
                            statusMessage.innerHTML = loaderStatus + "...";
                        },
                        showError: function (errorText) {
                            errorMessage.innerHTML = errorText;
                            loading.style.display = 'none';
                            error.style.display = 'block';
                            canvas.style.display = 'none';
                        },
                        showExit: function () {
                            statusMessage.innerHTML = "Application exit";
                            if (qtLoader.exitCode !== undefined)
                                statusMessage.innerHTML += " with code " + qtLoader.exitCode;
                            if (qtLoader.exitText !== undefined)
                                statusMessage.innerHTML += " (" + qtLoader.exitText + ")";
                            spinner.style.display = 'block';
                            canvas.style.display = 'none';
                        },
                        showCanvas: function () {
                            spinner.style.display = 'none';
                            canvas.style.display = 'block';
                        },
                        arguments: [
                            '--mqtt', 'wss://' + installation.mqtt_webhost + '/mqtt?idUser=' + user.id,
                            '--id', installation.identifier,
                            '--user', `vrmlogin_${vrmConfig.mqttApiEnvironment}_${user.email}`,
                            '--pass', new URLSearchParams(window.location.search).has('demoShare') ? vrmConfig.demoShareToken : localStorageService.get("token")
                        ],
                    });

                    qtLoader.loadEmscriptenModule("venus-gui-v2-loader", ApiService, $stateParams, installation.guiHash, true, locale);
                }
            });

        }
        open();
    };

}());


